import React from 'react';
import { connect } from 'react-redux';
import Resume from '../../components/Resume';
import TabsWithPanel from '../../components/TabsWithPanel';
import ContextMenu from '../../components/ContextMenu';
import { PlayList, Cover, MusicActions, RadioList } from '../../packages/components';
import {
    SimpleArtistGrid,
    SIMILAR_ARTISTS,
    ARTIST_ALBUMS
} from '../../containers/ArtistDetail/SimpleArtistGrid';
import { setResumeData } from '../../actions/resume';
import { addToContextMenu } from '../../actions/musica/context-menu-actions';
import { doPGMAlbum, doPGMSongs } from '../../actions/musica/player-shared-action-creators';
import { playFullMedia } from '../../actions/playmedia';
import logger from 'src/utils/logger/logger';
import PLAYERTRACK_TYPE from '../../containers/Music/playerTracksType';
import Device from '../../devices/device';
import MusicUtils from '../../actions/musica/music-actions';
import * as api from '../../requests/loader';
import PlayerTracksUtil from '../../utils/PlayerTracksUtils';
import Translator from '../../requests/apa/Translator';
import MusicActionsUtil from '../../utils/music/MusicActionsUtil';
import ArtistRadiosLive from './ArtistRadiosLive';

const mapDispatchToProps = dispatch => ({
    setResumeData: data => dispatch(setResumeData(data)),
    addToContextMenu: currentContent => dispatch(addToContextMenu(currentContent)),
    doPGMAlbum: (index, state) => dispatch(doPGMAlbum(index, state)),
    doPGMSongs: (index, state) => dispatch(doPGMSongs(index, state)),
    playFullMedia: pgm => dispatch(playFullMedia(pgm))
});

class NewArtistDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            artistId: props.match.params.artistId,
            data: null,
            selectedItem: null,
            components: [],
            isFetching: true
        };
        this.getData = this.getData.bind(this);
        this.setIsFetching = this.setIsFetching.bind(this);
        this.handleToggleFollowClick = this.handleToggleFollowClick.bind(this);
        this.handlePlayListOnClick = this.handlePlayListOnClick.bind(this);
        this.handlePlayListOnFocus = this.handlePlayListOnFocus.bind(this);
        this.handlePlayListOnBlur = this.handlePlayListOnBlur.bind(this);
        this.handleRadioListOnClick = this.handleRadioListOnClick.bind(this);
        this.handleRadioListOnFocus = this.handleRadioListOnFocus.bind(this);
        this.handleRadioListOnBlur = this.handleRadioListOnBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.handleAlbumOrArtistFocus = this.handleAlbumOrArtistFocus.bind(this);
        this.renderComponent = this.renderComponent.bind(this);
        this.keys = Device.getDevice().getKeys();
        this.contextMenu = null;
        this.playerTracks = new PlayerTracksUtil();
    }

    componentDidMount() {
        const { artistId } = this.state;
        this.getData(artistId);
    }

    componentWillReceiveProps(nextProps) {
        const newArtistId = nextProps.match.params.artistId;
        const { artistId } = this.state;
        if (artistId !== newArtistId) {
            this.setState({ artistId: newArtistId }, () => {
                const cb = () => {
                    // esto es para poner el primer tab activo
                    const selector = document.querySelector('.twp-tab-name');
                    if (selector && selector.click) {
                        selector.click();
                    }
                };
                this.setState({ isFetching: true });
                this.getData(newArtistId, cb);
            });
        }
    }

    setIsFetching(isFetching) {
        this.setState({ isFetching });
    }

    async getData(artistId, cb = null) {
        const params = {
            artistId: artistId
        };
        const response = await api.getArtistDetail(params);
        if (response) {
            this.setState(
                {
                    isFetching: false,
                    data: response && response.data ? response.data : null,
                    components: response && response.components ? response.components : []
                },
                () => {
                    if (response && response.data) {
                        const resumeData = { title: response.data.author };
                        this.setResume(resumeData);
                    }
                    if (typeof cb === 'function') {
                        cb();
                    }
                }
            );
        } else {
            this.setState({
                isFetching: false
            });
        }
    }

    setResume(data, overWrite = true) {
        const { data: stateData = {} } = this.state;
        const { author } = stateData;
        if (data) {
            const { setResumeData } = this.props;
            setResumeData({
                ...data,
                title: author,
                showBack: true,
                overWrite
            });
        }
    }

    onKeyDown(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        const focusedContent = this.getFocusedContent();
        switch (currentKey) {
            case 'BLUE':
            case 'PLAYPAUSE': // for new models samsung tizen small control
            case 'PAUSE':
            case 'PLAY':
                if (focusedContent) this.playByContent(focusedContent);
                break;
            case 'GREEN':
                this.handleMoreClick();
                break;
            case 'YELLOW':
                if (focusedContent) this.toggleFollowByContent(focusedContent);
                else this.handleToggleFollowClick();
                break;
            default:
                break;
        }
    }

    handleMoreClick() {
        const { addToContextMenu } = this.props;
        const { selectedItem } = this.state;
        addToContextMenu(selectedItem);
        const context = this.contextMenu.getWrappedInstance();
        context.showModal();
    }

    getFocusedContent() {
        const activeElement = document.activeElement;
        if (activeElement.hasAttribute('href')) {
            if (activeElement.href.indexOf('artist') !== -1) {
                return PLAYERTRACK_TYPE.ARTIST;
            }
            if (activeElement.href.indexOf('album') !== -1) {
                return PLAYERTRACK_TYPE.ALBUM;
            }
        }
        return false;
    }

    playByContent(content) {
        const { doPGMAlbum, playFullMedia } = this.props;
        const { selectedItem } = this.state;
        if (selectedItem.type === content) {
            MusicActionsUtil.playContent(
                {
                    type: selectedItem.type,
                    id: selectedItem.id
                },
                doPGMAlbum,
                playFullMedia
            );
        }
    }

    toggleFollowByContent(content) {
        const { selectedItem } = this.state;
        if (selectedItem.type === content) {
            MusicActionsUtil.toggleFollow({
                type: selectedItem.type,
                id: selectedItem.id
            })
                .then(result => {
                    logger.debug('toggleFollowByContent result', result);
                })
                .catch(error => {
                    logger.error(error);
                });
        }
    }

    handleToggleFollowClick() {
        const { components, data } = this.state;
        const [actionsComponent] = components;
        let url = '';
        if (data.isFollowed) {
            url = actionsComponent.properties.follow.url;
        } else {
            url = actionsComponent.properties.unfollow.url;
        }
        const headers = {};
        api.simpleCMMRequest(url, headers).then(success => {
            if (success) {
                this.setState(prevState => ({
                    data: { ...prevState.data, isFollowed: !prevState.data.isFollowed }
                }));
            }
        });
    }

    handlePlayListOnClick(song) {
        const { doPGMSongs, playFullMedia } = this.props;
        const { artistId, data: { tracks = [] } = {} } = this.state;
        MusicActionsUtil.playContent(
            {
                type: PLAYERTRACK_TYPE.ARTIST,
                id: artistId,
                tracks
            },
            doPGMSongs,
            playFullMedia,
            song.songIndex
        );
    }

    handlePlayListOnFocus(song) {
        const songId = song.phonogramId === '' ? song.songIndex : song.phonogramId;
        const el = document.getElementById(`song-${songId}`);

        el && el.classList.add('selected-song');

        this.setResume({ description: song.title });
        this.setState({ selectedItem: song });
    }

    handlePlayListOnBlur(song) {
        const songId = song.phonogramId === '' ? song.songIndex : song.phonogramId;
        const el = document.getElementById(`song-${songId}`);

        el && el.classList.remove('selected-song');
    }

    handleAlbumOrArtistFocus(data) {
        const elements = document.getElementsByClassName('focused');
        if (elements.length > 0) elements[0].classList.remove('focused');
        const selEl = document.getElementById(`card-${data.id}`);
        if (selEl) {
            selEl.classList.add('focused');
        }
        if (data.type === PLAYERTRACK_TYPE.ARTIST) {
            this.setResume({
                description: data.artist
            });
        }
        if (data.type === PLAYERTRACK_TYPE.ALBUM) {
            this.setResume({
                year: data.title,
                duration: `${data.numTracks} ${Translator.get('SONGS', 'canciones')}`
            });
        }
        this.setState({ selectedItem: data });
    }

    handleRadioListOnClick(song) {}

    handleRadioListOnFocus(song) {}

    handleRadioListOnBlur(song) {}

    renderComponent(component) {
        if (!component || !component.properties || !component.name) {
            return null;
        }
        switch (component.name) {
            case 'Actions':
                const { data } = this.state;
                const props = { ...component.properties };
                if (data.isFollowed) {
                    props.toggleFollow = props.unfollow;
                } else {
                    props.toggleFollow = props.follow;
                }
                delete props.follow;
                delete props.unfollow;
                return (
                    <MusicActions
                        {...props}
                        onToggleFollowClick={this.handleToggleFollowClick}
                        onKeyDown={this.onKeyDown}
                        device={MusicUtils.getMusicDevice()}
                    />
                );
            case 'Cover':
                return <Cover {...component.properties} />;
            case 'SongList':
                return (
                    <PlayList
                        {...component.properties}
                        onClick={this.handlePlayListOnClick}
                        onFocus={this.handlePlayListOnFocus}
                        onBlur={this.handlePlayListOnBlur}
                    />
                );
            case 'RadioList':
                return (
                    <RadioList
                        {...component.properties}
                        onClick={this.handleRadioListOnClick}
                        onFocus={this.handleRadioListOnFocus}
                        onBlur={this.handleRadioListOnBlur}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const { components, artistId, isFetching } = this.state;
        const [actionsComponent, coverComponent, songListComponent] = components;
        return (
            <div className="playlist-container">
                <Resume history={this.props.history}/>
                {this.renderComponent(actionsComponent)}
                <TabsWithPanel
                    defaultActiveTab={0}
                    isFetching={isFetching}
                    tabs={[
                        Translator.get('SONGS', 'CANCIONES'),
                        Translator.get('ALBUMS', 'ÁLBUMES'),
                        Translator.get('SIMILAR', 'SIMILARES'),
                        Translator.get('LIVE', 'EN VIVO')
                    ]}
                >
                    <div className="w_detail">
                        <div className="w_album">
                            <div>{this.renderComponent(coverComponent)}</div>
                        </div>
                        <div className="w_canciones" id="w_canciones">
                            {this.renderComponent(songListComponent)}
                        </div>
                    </div>
                    <SimpleArtistGrid
                        type={ARTIST_ALBUMS}
                        artistId={artistId}
                        onFocus={this.handleAlbumOrArtistFocus}
                        setIsFetching={this.setIsFetching}
                    />
                    <SimpleArtistGrid
                        type={SIMILAR_ARTISTS}
                        artistId={artistId}
                        onFocus={this.handleAlbumOrArtistFocus}
                        setIsFetching={this.setIsFetching}
                    />
                    <ArtistRadiosLive artistId={artistId} render={this.renderComponent} />
                </TabsWithPanel>
                <ContextMenu
                    ref={instance => {
                        this.contextMenu = instance;
                    }}
                />
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(NewArtistDetail);



// WEBPACK FOOTER //
// ./src/containers/ArtistDetail/NewArtistDetail.jsx